// import axios from 'axios'
import firestore from "@/firebase/firestore";
import api from "../../utils/api";

// const token = !localStorage.getItem('token')?false:localStorage.getItem('token')
// // if(token)
// //   axios.defaults.headers.get['Authorization'] = 'Bearer ' + token
// //   axios.defaults.headers.get['Content-Type'] = 'application/json'

// const config = {

//   headers: {
//     'Authorization': 'Bearer ' + token,
//     'Access-Control-Allow-Origin':'*'
//   }
// }

export const getCard = (card) => {
  return api.get(process.env.VUE_APP_GET_CARDS + "/" + card);
};

const anAsyncFunction = async (item) => {
  return getCard(item);
};

export const getCards = (cards) => {
  return Promise.all(
    cards.map((item) => {
      let res = anAsyncFunction(item);
      return res;
    }),
  );
};

// export const getCards = async (cards) => {
//     let _cards = []
//     console.log('çards l', cards.length)
//     for(let i=0; i < cards.length; i++) {
//         let res = api.get('https://api.prod.enercred.com.br/api/v1/cards/'+ cards[i])
//         console.log('res: ', await res)
//         _cards.push(await res)
//     }
//     return await _cards
//     // return Promise.all(cards.map(item => {
//     //     let res = api.get('https://api.prod.enercred.com.br/api/v1/cards/'+ item)
//     //     return res
//     // }))
// }

export const updateDefaultCard = async (userId, cardId) => {
  return await firestore.collection("users").doc(userId).update({
    card_default: cardId,
  });
};

// export const getCards = async (cards) => {
//     let c = await cards.map(async card => {
//         let newcard = await getCard(card)
//         console.log('card: ', newcard)
//         if(newcard.status === 200)
//             return newcard.data
//     })
//     console.log('c: ', c)
//     return c

// }
